import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetServicePointListPaginated = () =>
  useMutation({
    mutationFn: (data) => client(`resources/sites`, { data }),
  });

export const useAddServicePoint = () =>
  useMutation({
    mutationFn: (data) => client(`resources/sites/add`, { data }),
  });
